import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Grid2 } from "@mui/material";
import Button from "@mui/material/Button";
import * as XLSX from "xlsx"; // Import xlsx library to handle Excel files

function OATEval(mode) {
	console.log(mode);

	function handleFileChange(event) {
		const file = event.target.files[0];
		if (file && file.name.endsWith(".xlsx")) {
			console.log("File selected:", file.name);
			// Process the file locally or store it for later upload
			// For now, just log the file details
			console.log("File size:", file.size);
			console.log("File type:", file.type);
			//save the file locally
			const reader = new FileReader();
			reader.onload = (e) => {
				//interpret the file content since it is xlsx
				// console.log(e.target.result);
				// You can use a library like xlsx to parse the file content

				const workbook = XLSX.read(e.target.result, { type: "binary" });
				//loop through each sheet in the workbook
				workbook.SheetNames.forEach((sheetName) => {
					const worksheet = workbook.Sheets[sheetName];
					// console.log(worksheet);
					// Here you can process each worksheet as needed
					console.log(`Processing sheet: ${sheetName}`);
					// For example, you can convert the sheet to JSON
					const jsonData = XLSX.utils.sheet_to_json(worksheet);
					console.log(jsonData);
				});
			};
			reader.readAsBinaryString(file);

			// alert("File uploaded successfully: " + file.name);
		} else {
			alert("Please upload a valid .xlsx file.");
		}
	}

	return (
		<div id="htmlPage">
			<h1>OAT Evaluation System</h1>
			<Grid2 container spacing={5}>
				<Grid2 container spacing={2} direction="column">
					<FormControl sx={{ m: 1, width: 300 }}>
						<input
							id="upload-input"
							type="file"
							accept=".xlsx"
							onChange={handleFileChange}
							style={{ display: "none" }}
						/>
						<label htmlFor="upload-input">
							<Button variant="contained" component="span">
								Upload Excel File
							</Button>
						</label>
					</FormControl>
				</Grid2>
				<Grid2 container xs={10} id="ads"></Grid2>
			</Grid2>
		</div>
	);
}

export default OATEval;
